module.exports = __webpack_public_path__ + "img/horizontal_6_7_8019.a0099b20.png";